<template>
  <div
    :class="['weather-statement', { 'with-countdown': withCountdown }]"
    v-html="statementHtml"
  />
</template>

<script>
export default {
  name: 'WeatherStatement',
  props: {
    statementHtml: {
      type: String,
      required: true
    },
    withCountdown: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss">
#core-availability {
  .weather-statement {
    border: 5px solid $warning;
    padding: 10px 15px;
    font-size: $font-size-14px;
    margin-bottom: 1rem;

    &.with-countdown {
      $banner-padding: 10px;

      @include media-breakpoint-up($countdown-banner-visible-breakpoint) {
        $banner-width-plus-padding: $countdown-banner-width + $countdown-banner-right-default + $banner-padding;
        max-width: calc(100% - #{$banner-width-plus-padding});
      }

      @include media-breakpoint-up(lg) {
        $banner-width-plus-padding: $countdown-banner-width + $countdown-banner-right-lg + $banner-padding;
        max-width: calc(100% - #{$banner-width-plus-padding});
      }
    }
  }
}
</style>
